(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-about-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-about-editorial')) {
  customElements.define('sf-about-editorial', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      if (!this.hasAttribute('data-sf-about-parallax')) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.sf-info-scene');
      this.image = this.querySelector('.sf-info-scene img');
      this.article = this.querySelector('.sf-about-actions') || this.querySelector('.sf-about-related') || this.querySelector('.sf-about-panel');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.image.addEventListener('load', this.schedule, { signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.article.getBoundingClientRect();
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      const imageOffset = this.motion.matches ? 0 : wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-acropora-care"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-acropora-care')) {
  customElements.define('sf-acropora-care', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.ac-guide-toc a[href^="#"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        this.querySelector('.ac-guide-toc').open = false;
        target?.focus({ preventScroll: true });
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }
    initializeBackground(signal) {
      this.scene = this.querySelector('.ac-scene');
      this.image = this.querySelector('.ac-scene img');
      this.article = this.querySelector('.ac-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0; this.image = null; this.scene = null; this.article = null;
    }
    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const contentHeight = this.article.getBoundingClientRect().height;
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, contentHeight - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = `translateY(${sceneOffset}px)`;
      this.image.style.width = `${this.image.naturalWidth * scale}px`;
      this.image.style.height = `${renderedHeight}px`;
      this.image.style.transform = `translate(-50%, ${-wallpaperTravel * progress}px)`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-aefw"]) return;
  try {
    
if (!customElements.get('sf-aefw')) {
  customElements.define('sf-aefw', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-aiptasia-majanos"]) return;
  try {
    

if (!customElements.get('sf-aiptasia-majanos')) {
  customElements.define('sf-aiptasia-majanos', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-anemone-care"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sf-care-master')) {
  customElements.define('sf-care-master', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.care-guide-toc a[href^="#"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        this.querySelector('.care-guide-toc').open = false;
        target?.focus({ preventScroll: true });
      }, { signal });

      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }
    initializeBackground(signal) {
      this.scene = this.querySelector('.care-scene');
      this.image = this.querySelector('.care-scene img');
      this.article = this.querySelector('.care-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0; this.image = null; this.scene = null; this.article = null;
    }
    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const contentHeight = this.article.getBoundingClientRect().height;
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, contentHeight - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = `translateY(${sceneOffset}px)`;
      this.image.style.width = `${this.image.naturalWidth * scale}px`;
      this.image.style.height = `${renderedHeight}px`;
      this.image.style.transform = `translate(-50%, ${-wallpaperTravel * progress}px)`;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-care-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-care-hub')) {
  customElements.define('sf-care-hub', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.sf-care-scene');
      this.image = this.querySelector('.sf-care-scene img');
      this.article = this.querySelector('.sf-care-chapters');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.image.addEventListener('load', this.schedule, { signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.article.getBoundingClientRect();
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-care-master"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sf-care-master')) {
  customElements.define('sf-care-master', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.care-guide-toc a[href^="#"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        this.querySelector('.care-guide-toc').open = false;
        target?.focus({ preventScroll: true });
      }, { signal });

      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }
    initializeBackground(signal) {
      this.scene = this.querySelector('.care-scene');
      this.image = this.querySelector('.care-scene img');
      this.article = this.querySelector('.care-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0; this.image = null; this.scene = null; this.article = null;
    }
    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const contentHeight = this.article.getBoundingClientRect().height;
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, contentHeight - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = `translateY(${sceneOffset}px)`;
      this.image.style.width = `${this.image.naturalWidth * scale}px`;
      this.image.style.height = `${renderedHeight}px`;
      this.image.style.transform = `translate(-50%, ${-wallpaperTravel * progress}px)`;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-copepods"]) return;
  try {
    

if (!customElements.get('sf-copepods')) {
  customElements.define('sf-copepods', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-drupella"]) return;
  try {
    

if (!customElements.get('sf-drupella')) {
  customElements.define('sf-drupella', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-eefw"]) return;
  try {
    

if (!customElements.get('sf-eefw')) {
  customElements.define('sf-eefw', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-footer"]) return;
  try {
    
  function initialiseFooterGroups(root = document) {
    const mobile = window.matchMedia('(max-width: 750px)');
    root.querySelectorAll('.sf-home-footer-group').forEach((group) => {
      if (group.dataset.footerReady) return;
      group.dataset.footerReady = 'true';
      const summary = group.querySelector('summary');
      const update = () => {
        group.open = !mobile.matches;
        summary.tabIndex = mobile.matches ? 0 : -1;
      };
      summary.addEventListener('click', (event) => {
        if (!mobile.matches) event.preventDefault();
      });
      mobile.addEventListener('change', update);
      update();
    });
  }
  initialiseFooterGroups();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFooterGroups(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-goniopora-nudibranchs"]) return;
  try {
    

if (!customElements.get('sf-goniopora-nudibranchs')) {
  customElements.define('sf-goniopora-nudibranchs', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-information"]) return;
  try {
    
if (!customElements.get('sf-info-parallax-page')) {
  customElements.define('sf-info-parallax-page', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      if (!this.hasAttribute('data-sf-info-parallax')) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.sf-info-scene');
      this.image = this.querySelector('.sf-info-scene img');
      this.article = this.querySelector('.sf-info-article');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.image.addEventListener('load', this.schedule, { signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.article.getBoundingClientRect();
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      const imageOffset = this.motion.matches ? 0 : wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-montipora-nudibranchs"]) return;
  try {
    

if (!customElements.get('sf-montipora-nudibranchs')) {
  customElements.define('sf-montipora-nudibranchs', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-new-aefw"]) return;
  try {
    

if (!customElements.get('sf-new-aefw')) {
  customElements.define('sf-new-aefw', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-reviews')) {
  customElements.define('sf-reviews', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.link = this.querySelector('[data-review-link]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.current = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inView = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const manual = index => { this.paused = true; this.show(index, true); this.updatePause(); this.schedule(); };
      this.querySelector('[data-previous]')?.addEventListener('click', () => manual(this.current - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => manual(this.current + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => manual(index), options));
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); manual(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .25 });
      this.observer.observe(this);
      this.editHandler = event => { const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target); if (index >= 0) manual(index); };
      document.addEventListener('shopify:block:select', this.editHandler, options);
      this.updatePause();
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[position]?.setAttribute('aria-current', String(active));
      });
      const active = this.slides[this.current];
      if (this.link) this.link.href = active.dataset.sourceUrl;
      if (announce) this.querySelector('[data-announcement]').textContent = active.getAttribute('aria-label') + ': ' + active.querySelector('.sf-reviews__author').textContent;
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || !this.inView || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, 9000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-sea-spiders"]) return;
  try {
    

if (!customElements.get('sf-sea-spiders')) {
  customElements.define('sf-sea-spiders', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-search"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-sf-search-form]');
  if (!form) return;
  const input = form.querySelector('[data-sf-search-input]');
  const query = form.querySelector('[data-sf-search-query]');
  if (input.value === input.dataset.original) return;
  const scopedTags = query.value.match(/tag:(?:"[^"]*"|\S+)/g) || [];
  const words = input.value.trim().replace(/["\\]/g, ' ').split(/\s+/).filter(Boolean);
  query.value = scopedTags.concat(words.map(word => '"' + word + '"')).join(' AND ');
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sf-search-sort]')) event.target.form.requestSubmit();
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-sf-search] .sf-search-filter[open]').forEach(details => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-sps-care"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-sps-care')) {
  customElements.define('sf-sps-care', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.care-guide-toc a[href^="#"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        this.querySelector('.care-guide-toc').open = false;
        target?.focus({ preventScroll: true });
      }, { signal });

      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }
    initializeBackground(signal) {
      this.scene = this.querySelector('.sps-scene');
      this.image = this.querySelector('.sps-scene img');
      this.article = this.querySelector('.sps-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0; this.image = null; this.scene = null; this.article = null;
    }
    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const contentHeight = this.article.getBoundingClientRect().height;
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, contentHeight - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = `translateY(${sceneOffset}px)`;
      this.image.style.width = `${this.image.naturalWidth * scale}px`;
      this.image.style.height = `${renderedHeight}px`;
      this.image.style.transform = `translate(-50%, ${-wallpaperTravel * progress}px)`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-zoanthid-nudibranchs"]) return;
  try {
    

if (!customElements.get('sf-zoanthid-nudibranchs')) {
  customElements.define('sf-zoanthid-nudibranchs', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', (event) => {
        if (event.target.closest('.sf-pest-toc a[href^="#"]')) {
          this.querySelector('.sf-pest-toc').open = false;
        }
      }, { signal });
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (!this.isConnected || signal.aborted) return;
          if (!this.image) this.initializeBackground(signal);
          this.updateBackground();
        });
      };
      this.schedule();
    }

    initializeBackground(signal) {
      this.scene = this.querySelector('.aefw-scene');
      this.image = this.querySelector('.aefw-scene img');
      this.article = this.querySelector('.aefw-content');
      if (!this.scene || !this.image || !this.article) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', this.schedule, { signal });
      document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('orientationchange', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
      this.addEventListener('load', this.schedule, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(this.schedule);
      for (let element = this; element; element = element.parentElement) {
        this.resizeObserver.observe(element);
      }
      this.resizeObserver.observe(this.article);
      document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.image = null;
      this.scene = null;
      this.article = null;
    }

    updateBackground() {
      if (!this.scene || !this.image?.naturalWidth || !this.image.naturalHeight || !this.article) return;
      let viewportTop = 0;
      let viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      for (let ancestor = this.parentElement; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
        if (/(auto|scroll|hidden|overlay)/.test(getComputedStyle(ancestor).overflowY)) {
          viewportTop = ancestor.getBoundingClientRect().top + ancestor.clientTop;
          viewportHeight = ancestor.clientHeight;
          break;
        }
      }
      const sectionRect = this.getBoundingClientRect();
      const articleRect = this.getBoundingClientRect();
      this.style.setProperty('--aefw-nav-height', this.querySelector('.sf-pest-toc summary').offsetHeight + 'px');
      const viewportWidth = sectionRect.width;
      if (!viewportHeight || !viewportWidth) return;
      const scrollDistance = Math.max(0, articleRect.bottom - sectionRect.top - viewportHeight);
      const localScroll = Math.max(0, viewportTop - sectionRect.top);
      const progress = scrollDistance > 0 ? Math.min(1, localScroll / scrollDistance) : 0;
      const sceneHeight = Math.min(viewportHeight, sectionRect.height);
      const sceneOffset = Math.min(localScroll, Math.max(0, sectionRect.height - sceneHeight));
      const scale = Math.max(viewportWidth / this.image.naturalWidth, viewportHeight * 1.35 / this.image.naturalHeight);
      const renderedHeight = this.image.naturalHeight * scale;
      const wallpaperTravel = Math.max(0, renderedHeight - sceneHeight);
      if (this.motion.matches) {
        this.scene.style.height = ''; this.scene.style.transform = '';
        this.image.style.width = ''; this.image.style.height = ''; this.image.style.transform = '';
        return;
      }
      const imageOffset = wallpaperTravel * progress;
      this.scene.style.height = sceneHeight + 'px';
      this.scene.style.transform = 'translate3d(0, ' + sceneOffset + 'px, 0)';
      this.image.style.width = this.image.naturalWidth * scale + 'px';
      this.image.style.height = renderedHeight + 'px';
      this.image.style.transform = 'translate3d(-50%, ' + (-imageOffset) + 'px, 0)';
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
